export enum STATUS {
  EDIT = "edit",
  WAIT = "wait",
  RELEASE = "release",
  NO_RELEASE = "no_release",
}

export const STATUS_NAME = {
  [STATUS.EDIT]: "編集中",
  [STATUS.WAIT]: "公開待ち",
  [STATUS.RELEASE]: "公開中",
  [STATUS.NO_RELEASE]: "非公開",
};

export const STATUS_NAME_INPUT = {
  [STATUS.EDIT]: "編集中",
  [STATUS.RELEASE]: "公開",
  [STATUS.NO_RELEASE]: "非公開",
};

export const STATUS_CSS = {
  [STATUS.EDIT]: "editing",
  [STATUS.WAIT]: "wait",
  [STATUS.RELEASE]: "release",
  [STATUS.NO_RELEASE]: "no_release",
};

export const STATUS_ARRAY = [
  { id: STATUS.EDIT, name: STATUS_NAME[STATUS.EDIT] },
  { id: STATUS.WAIT, name: STATUS_NAME[STATUS.WAIT] },
  { id: STATUS.RELEASE, name: STATUS_NAME[STATUS.RELEASE] },
  { id: STATUS.NO_RELEASE, name: STATUS_NAME[STATUS.NO_RELEASE] },
];

export const STATUS_ARRAY_INPUT = [
  { id: STATUS.EDIT, name: STATUS_NAME_INPUT[STATUS.EDIT] },
  { id: STATUS.RELEASE, name: STATUS_NAME_INPUT[STATUS.RELEASE] },
  { id: STATUS.NO_RELEASE, name: STATUS_NAME_INPUT[STATUS.NO_RELEASE] },
];

export enum SETTING {
  NOW = "now",
  DATE = "date",
}

export const SETTING_NAME = {
  [SETTING.NOW]: "今すぐ公開",
  [SETTING.DATE]: "日時指定",
};

export enum CATEGORIES_KEY {
  CATEGORY_NEWS = "News",
  CATEGORY_KOI = "No.1Koi",
  CATEGORY_EVENT = "StoreEvent",
  CATEGORY_STORE = "Store",
  CATEGORY_SHOW = "ShowWinners",
}

export const CATEGORIES = {
  [CATEGORIES_KEY.CATEGORY_NEWS]: "お知らせ",
  [CATEGORIES_KEY.CATEGORY_KOI]: "ライブ鯉",
  [CATEGORIES_KEY.CATEGORY_EVENT]: "イベント",
  [CATEGORIES_KEY.CATEGORY_STORE]: "ストア",
  [CATEGORIES_KEY.CATEGORY_SHOW]: "品評会",
};

export const CATEGORIES_ARRAY = [
  {
    id: CATEGORIES_KEY.CATEGORY_NEWS,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_NEWS],
  },
  {
    id: CATEGORIES_KEY.CATEGORY_KOI,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_KOI],
  },
  {
    id: CATEGORIES_KEY.CATEGORY_EVENT,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_EVENT],
  },
  {
    id: CATEGORIES_KEY.CATEGORY_STORE,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_STORE],
  },
  {
    id: CATEGORIES_KEY.CATEGORY_SHOW,
    name: CATEGORIES[CATEGORIES_KEY.CATEGORY_SHOW],
  },
];

export const DEFAULT_IMAGE_KEYS = {
  IMAGE_1: "1",
  IMAGE_2: "2",
  IMAGE_3: "3",
  IMAGE_4: "4",
  IMAGE_5: "5",
};

export const DEFAULT_IMAGES = {
  [DEFAULT_IMAGE_KEYS.IMAGE_1]: "news_01.jpg",
  [DEFAULT_IMAGE_KEYS.IMAGE_2]: "news_02.jpg",
  [DEFAULT_IMAGE_KEYS.IMAGE_3]: "news_03.jpg",
  [DEFAULT_IMAGE_KEYS.IMAGE_4]: "news_04.jpg",
  [DEFAULT_IMAGE_KEYS.IMAGE_5]: "news_05.jpg",
};
